import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";


@Injectable()
export class DataStorageService {
    private localStorageChangeHandler = new Subject<any>();
    constructor() {

    }


    /**
     * Set data in localStorage
     *
     * @param args
     * @returns {this}
     */
    // @ts-ignore
    public setData(...args) {
        // @ts-ignore
        for (let i = 0; i < args.length; i = i + 2) {
            // @ts-ignore
            localStorage.setItem(args[ i ], JSON.stringify(args[ i + 1 ]));
            this.sendLocalStorageChanged(args[ i ]);
        }
        return this;
    }

    /**
     * Get data from local storage
     * @param {string} key
     * @returns {any}
     */
    public getData(key: string) {
        const item = localStorage.getItem(key);

        // Try catch for json parse errors on undefined variables
        try {
            // @ts-ignore
            return JSON.parse(item);
        } catch (e) {
            return undefined;
        }
    }

    /**
     * Remove data from local storage
     *
     * @param keys
     */
    public removeData(...keys:any[]) {
        for (const key of keys) {
            if (key !== 'authentication-token' || key !== 'user') {
                localStorage.removeItem(key);
            } else {
               // this.toasterService.pop('error', 'You can\'t do this action!');
            }
        }
    }


    /**
     * Function that simulates $rootScope.$broadcast from angular 1
     */
    sendLocalStorageChanged(keyValue: { [key: string]: string }) {
        this.localStorageChangeHandler.next(keyValue);
    }

    /**
     * Function that simulates $rootScope.$on from angular 1
     */
    getLocalStorageChanged(): Observable<any> {
        return this.localStorageChangeHandler.asObservable();
    }
}
